/**
 * "Fulano está escribiendo...".
 *
 * Ocupa sitio siempre que hay alguien escribiendo y desaparece del todo cuando
 * no: reservarle una línea fija movería el chat en cada tecla.
 */
export default function ChatTyping({ people }) {
    if (!people.length) return null;

    const names = people.slice(0, 2).map((person) => person.name).join(', ');
    const others = people.length - 2;

    return (
        <p className="chat-typing">
            <span className="chat-typing-dots"><span></span><span></span><span></span></span>
            {others > 0
                ? `${names} y ${others} más están escribiendo`
                : `${names} ${people.length > 1 ? 'están' : 'está'} escribiendo`}
        </p>
    );
}
